
export const ICONS = {
  P2E: 'https://files.peakd.com/file/peakd-hive/gaottantacinque/23wBxxdKiJQ32FjeTVC55mChN5i2eGeyECztSFE71Ng8hAuvzrWjCL7UaKmwWGWYuLKQZ.png',
  F2P: 'https://files.peakd.com/file/peakd-hive/gaottantacinque/EoiTEbnkLJAfWmUhqwcaAJm8KS1a4wTfeMyWUJKG8GfWTaWr8GjUmnGg2Z6xYsedCQ7.png',
  CONTROLLER: 'https://www.glyphicons.com/img/glyphicons/basic/2x/glyphicons-basic-413-game-controller@2x.png',
};
